// Utility function to get item from sessionStorage and parse JSON
export const getSessionStorageItem = (key) => {
  const storedItem = sessionStorage.getItem(key);
  return storedItem ? JSON.parse(storedItem) : null;
};
